<template>
    <div class="content">
        <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">节次管理</h3>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
                <el-form-item>
                    <el-button type="primary" @click="handleAdd()">新增节次</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <custom-table :data="tableData" ref="table" border style="width: 100%">
                <custom-table-column prop="name" label="节次名称" width="150">
                </custom-table-column>
                <custom-table-column prop="course_type" label="节次归属" width="150">
                </custom-table-column>
                <custom-table-column prop="start_time" label="开始时间" width="150">
                </custom-table-column>
                <custom-table-column prop="end_time" label="结束时间" width="150">
                </custom-table-column>
                <custom-table-column prop="remark" label="备注">
                </custom-table-column>
                <custom-table-column label="状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" style="color: var(--red);">停用</span>
                        <span v-else style="color: var(--blue);">启用</span>
                    </template>
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="handleEditNew(scope.row, ['id','status'], () => { })" type="text"
                            size="small">编辑</el-button>
                        <el-button v-if="scope.row.status == 1" @click="handleStatus(scope.row, 0)" type="text"
                            size="small">启用</el-button>
                        <el-button v-else @click="handleStatus(scope.row, 1)" type="text" size="small">停用</el-button>
                    </template>
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="500px">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="节次名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入节次名称" style="width:266px;"></el-input>
                </el-form-item>
                <el-form-item label="开始时间" prop="start_time">
                    <el-time-picker v-model="ruleForm.start_time" value-format="HH:mm" placeholder="选择开始时间"
                        style="width:266px;"></el-time-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="end_time">
                    <el-time-picker v-model="ruleForm.end_time" value-format="HH:mm" placeholder="选择结束时间"
                        style="width:266px;"></el-time-picker>
                </el-form-item>
                <el-form-item label="节次归属" prop="course_type">
                    <el-select v-model="ruleForm.course_type" style="width:266px;" placeholder="请选择节次归属">
                        <el-option v-for="item in $store.state.periodFrom" :key="item" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="ruleForm.remark" placeholder="请输入备注"
                        style="width:266px;"></el-input>
                </el-form-item>
                <el-form-item style="margin-top:8px;width:100%;text-align:right;">
                    <el-button type="primary" v-if="type == 'add'"
                        @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
                    <el-button type="primary" v-if="type == 'edit'"
                        @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
                    <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
    name: 'periodManage',
    mixins: [mixinList],
    data() {
        return {
            formInline: {},
            ruleForm: {
                name: '',
                start_time: '',
                end_time: '',
                course_type:'上课时间',
                remark: '',
            },
            rules: {
                name: [{ required: true, message: '请输入节次名称', trigger: 'blur' }],
                start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
                course_type: [{ required: true, message: '请选择节次归属', trigger: 'change' }],
            },
        };
    },
    methods: {
        // 查询时重置到第一页
        handleQuery() {
            this.$refs.pageChild.page = 1;
            this.getList();
        },
        // 获取节次列表
        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/period/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        // 新增节次
        async createMethod() {
            let params = this.$until.deleteNullPrototype(this.ruleForm);
            let res = await this.$api.instance.interfaceServer('api/period/add', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '新增成功',
                });
                this.clearState();
            }
        },
        // 编辑节次
        async updateMethod() {
            let params = this.$until.easyDeepCopy(this.ruleForm);
            let res = await this.$api.instance.interfaceServer('api/period/edit', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '设置成功',
                });
                this.clearState();
            }
        },
        // 启用/停用节次：携带整行数据并覆盖状态，走 edit 接口
        handleStatus(row, status) {
            let params = this.$until.easyDeepCopy(row);
            params.status = status;
            this.confirmBox('warning', `确定要${status == 1 ? '停用' : '启用'}该节次吗？`, params, this.setStatus);
        },
        async setStatus(params) {
            this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
            this.ruleForm = this.assignFormObj(this.ruleForm, params, ['id', 'status'])
            this.updateMethod()
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: 96px;
}
</style>
